import { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import { baseUrl } from '../constants/url'

const AdminLogin = () => {
    const [isLoggedin, setIsLoggedIn] = useState(false)
    const [step, setStep] = useState(1) // 1 = userId/password, 2 = OTP
    const [userId, setUserId] = useState('')
    const [password, setPassword] = useState('')
    const [otp, setOtp] = useState('')
    const [mobileNumber, setMobileNumber] = useState('')
    const [isAdmin, setIsAdmin] = useState(false)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    const navigate = useNavigate()

    const handleAdminLogin = async (e) => {
        e.preventDefault();
        setError("");
        if (!userId || !password) {
            setError("Please enter User ID and Password");
            return;
        }
        try {
            setLoading(true);
            const response = await fetch(`${baseUrl}/admin/login`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    user_id: userId,
                    password: password,
                }),
            });
            const data = await response.json();
            console.log("🚀 ~ handleAdminLogin ~ response:", response);
            console.log("🚀 ~ handleAdminLogin ~ data:", data);
            if ((response.status >= 200 && response.status < 300) || response.status === 304) {
                // Upstream success flag
                const isSuccess =
                    data?.data?.isSuccess ??
                    data?.isSuccess;
                if (isSuccess === false) {
                    setError(
                        data?.data?.errorMessage ||
                        data?.errorMessage ||
                        data?.message ||
                        "Invalid credentials"
                    );
                    return;
                }

                // Extract mobileNo and isAdmin from response
                const result =
                    data?.data?.result ??
                    data?.result ??
                    data?.data ??
                    data;
                const respMobile =
                    result?.mobileNo ??
                    result?.mobileNumber;
                const respIsAdmin =
                    result?.isAdmin ??
                    data?.data?.isAdmin ??
                    data?.isAdmin ??
                    true; // admin endpoint → implicitly admin

                if (respMobile === undefined || respMobile === null) {
                    setError(
                        data?.data?.errorMessage ||
                        data?.message ||
                        "Invalid credentials"
                    );
                    return;
                }

                setMobileNumber(respMobile);
                setIsAdmin(!!respIsAdmin);
                setStep(2);
            } else {
                setError(data?.message || "Login failed");
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleVerifyOtp = async (e) => {
        e.preventDefault();
        setError("");
        if (!otp) {
            setError("Please enter OTP");
            return;
        }
        try {
            setLoading(true);
            const res = await fetch(`${baseUrl}/verifyuser`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    mobileNo: mobileNumber,
                    OTPText: parseInt(otp),
                    isAdmin: isAdmin,
                }),
            });
            const data = await res.json();
            if (res.status === 200) {
                // Upstream success flag
                const isSuccess =
                    data?.data?.isSuccess ??
                    data?.isSuccess;
                if (isSuccess === false) {
                    setError(
                        data?.data?.errorMessage ||
                        data?.errorMessage ||
                        data?.message ||
                        "Verification failed"
                    );
                    return;
                }

                // Upstream payload usually lives at data.data.result;
                // fall back to data.data when the legacy/test branch returns a flat shape.
                const result =
                    data?.data?.result ??
                    data?.result ??
                    data?.data ??
                    {};

                const token = result?.token;
                const memberId = result?.memberId ?? result?.ID;
                // memberCode may come as integer (e.g. 1010101) with a separate
                // categoryCode (e.g. "ADM"); middleware expects "ADM-1010101".
                let memberCode = result?.memberCode;
                const categoryCode = result?.categoryCode ?? result?.CategoryCode;
                if (memberCode !== undefined && memberCode !== null) {
                    memberCode = String(memberCode);
                    if (categoryCode && !memberCode.includes('-')) {
                        memberCode = `${categoryCode}-${memberCode}`;
                    }
                }

                if (token) {
                    const stored = { ...result, token, memberId, memberCode };
                    localStorage.setItem('localuser', JSON.stringify(stored));
                    localStorage.setItem('MemberAuth', token);
                    if (memberCode) localStorage.setItem('MemberCode', memberCode);
                    if (memberId !== undefined && memberId !== null) {
                        localStorage.setItem('MemberId', String(memberId));
                    }
                    // Keep legacy keys in sync for components that still rely on them
                    localStorage.setItem('Authorization', token);
                    localStorage.setItem('lastAuthTimeMillis', String(new Date().getTime()));
                    localStorage.setItem('isAdminLogin', true);
                    setIsLoggedIn(true);
                } else {
                    setError(
                        data?.data?.errorMessage ||
                        data?.message ||
                        "Verification failed"
                    );
                }
            } else {
                setError(data?.message || "Invalid OTP");
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleBack = () => {
        setStep(1);
        setOtp('');
        setError('');
    };

    useEffect(() => {
        if (isLoggedin) {
            navigate('/admin/dashboard')
        }
    }, [isLoggedin])

    return (
        <>
            <div className="login">
                <div className="login-page">
                    <h1>Admin Login</h1>
                    <div className="card">
                        {step === 1 ? (
                            <form className="form-part" onSubmit={handleAdminLogin}>
                                <div className="form-field">
                                    <input
                                        disabled={loading}
                                        type="text"
                                        placeholder="User ID"
                                        value={userId}
                                        onChange={(e) => {
                                            setUserId(e.target.value);
                                            setError("");
                                        }}
                                    />
                                </div>
                                <div className="form-field">
                                    <input
                                        disabled={loading}
                                        type="password"
                                        placeholder="Password"
                                        value={password}
                                        onChange={(e) => {
                                            setPassword(e.target.value);
                                            setError("");
                                        }}
                                    />
                                </div>
                                {error && <p style={{ color: 'red' }}>{error}</p>}
                                <div className="button-part">
                                    <button
                                        onClick={handleAdminLogin}
                                        className="submit-btn"
                                        disabled={!userId || !password || loading}
                                        type="submit"
                                    >
                                        {loading ? 'Loading...' : 'Login'}
                                    </button>
                                </div>
                            </form>
                        ) : (
                            <form className="form-part" onSubmit={handleVerifyOtp}>
                                <div className="form-field">
                                    <input
                                        disabled={loading}
                                        placeholder="Enter OTP"
                                        type="text"
                                        value={otp}
                                        onChange={(e) => {
                                            setOtp(e.target.value);
                                            setError("");
                                        }}
                                        autoFocus
                                    />
                                </div>
                                {error && <p style={{ color: 'red' }}>{error}</p>}
                                <div className="button-part">
                                    <button
                                        onClick={handleVerifyOtp}
                                        className="submit-btn"
                                        disabled={!otp || loading}
                                        type="submit"
                                    >
                                        {loading ? 'Loading...' : 'Verify'}
                                    </button>
                                </div>
                                <div className="button-part" style={{ marginTop: '10px' }}>
                                    <button
                                        onClick={handleBack}
                                        className="send-otp-link"
                                        disabled={loading}
                                        type="button"
                                    >
                                        Back
                                    </button>
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

export default AdminLogin
